
<script>
export default {
  name: "OrderBottomSheet",
  props: {

    cartTotal:{ type : String , dfault: null},
    draftCountItems:{ type: Number,default: null},

    errorBody: {
      type: Object,
      default: () => ({})
    },
  },

  computed: {

    requiredFields(){
       return this.errorBody?.data?.requiredFields
    },

    selectedFields(){
       return this.errorBody?.data?.selectedFields
    },

    customerDataInformation(){
       return this.errorBody?.data?.customerDataInformation
    },

    fullNameRequired() {
      return this.requiredFields?.includes("FULL_NAME") || false;
    },
    phoneRequired() {
      return this.requiredFields?.includes("PHONE") || false;
    },
    addressRequired() {
      return this.requiredFields?.includes("ADDRESS") || false;
    },
    emailRequired() {
      return this.requiredFields?.includes("MAIL") || false;
    },
    ageRequired() {
      return this.requiredFields?.includes("AGE") || false;
    },
    genderRequired() {
      return this.requiredFields?.includes("GENDER") || false;
    },
    customFieldsRequired() {
      return this.requiredFields?.includes("CUSTOM_FIELDS") || false;
    },
    customDropDownRequired() {
      return this.requiredFields?.includes("CUSTOM_DROP_DOWN") || false;
    },


    fullNameSelected() {
      return this.selectedFields?.includes("FULL_NAME") || false;
    },
    phoneSelected() {
      return this.selectedFields?.includes("PHONE") || false;
    },
    addressSelected() {
      return this.selectedFields?.includes("ADDRESS") || false;
    },
    emailSelected() {
      return this.selectedFields?.includes("MAIL") || false;
    },
    ageSelected() {
      return this.selectedFields?.includes("AGE") || false;
    },
    genderSelected() {
      return this.selectedFields?.includes("GENDER") || false;
    },
    customFieldsSelected() {
      return this.selectedFields?.includes("CUSTOM_FIELDS") || false;
    },
    customDropDownSelected() {
      return this.selectedFields?.includes("CUSTOM_DROP_DOWN") || false;
    },

    fieldsQuestion() {
      return this.errorBody?.data?.fieldsQuestion || "Custom Field";
    },

    cartNote() {
      return this.errorBody?.data?.cartNote || null;
    },

    dropDownQuestion() {
      return this.errorBody?.data?.dropDownQuestion || "Select Option";
    },

    ageRanges() {
      return this.errorBody?.data?.ageRanges || ["18-25", "26-35", "36-45", "46+"];
    },
    dropDownResponse() {
      return this.errorBody?.data?.dropDownResponse || [];
    },

    validationErrors() {
      const errors = {};

      if (this.fullNameRequired && !this.customerDataInformation.name) {
        errors.name = "Le nom et prénom sont obligatoires.";
      }

      if (this.phoneRequired && !this.customerDataInformation.phone) {
        errors.phone = "Le numéro de téléphone est obligatoire.";
      }

      if (this.emailRequired && !this.customerDataInformation.mail) {
        errors.mail = "L'email est obligatoire.";
      }

      if (this.addressRequired && !this.customerDataInformation.address) {
        errors.address = "L'adresse est obligatoire.";
      }

      if (this.ageRequired && !this.customerDataInformation.age) {
        errors.age = "La tranche d'âge est obligatoire.";
      }

      if (this.genderRequired && !this.customerDataInformation.gender) {
        errors.gender = "Le genre est obligatoire.";
      }

      if (this.genderRequired && !this.customerDataInformation.customDropDown) {
        errors.customDropDown = "Ce champs est obligatoire.";
      }

      if (this.customFieldsRequired && !this.customerDataInformation.customFields) {
        errors.customFields = "Ce champs est obligatoire.";
      }

      return errors;
    },

  },
  data() {
    return {
      rgbText: "#000000",
      genderTypes: ["Homme", "Femme"],
      isOrderRequiredSheetOpen: false,
    };
  },
  watch: {
    isOrderRequiredSheetOpen(val) {
      if (val) {
        history.pushState(null, null, location.href);
        window.onpopstate = () => {
          this.isOrderRequiredSheetOpen = false;
          this.close();
        };
      } else {
        window.onpopstate = null;
      }
    }
  },
  methods: {

    getGenderFromValue(gender) {
      switch (gender) {
          case 0:
              return "Homme";
          case 1:
              return "Femme";
          case 2:
              return "Indéfini";
          default:
              return "Indéfini";
      }
    },
    
    closeOrderRequiredDataSheet() {
      this.isOrderRequiredSheetOpen = false;
      this.$emit("closeOrderRequiredDataSheet");
    },
    close() {
      this.isOrderRequiredSheetOpen = false;
      this.$refs.orderSheet.close();
      this.closeOrderRequiredDataSheet();
    },
    open() {
      this.isOrderRequiredSheetOpen = true;
      this.$refs.orderSheet.open();
    },
    expandSheet() {
      this.$nextTick(() => {
        this.$refs.orderSheet.open();
      });
    },
    setAge(range) {
      this.customerDataInformation.age = range;
    },
    setGender(gender) {
      this.customerDataInformation.gender = gender;
    },
    checkout() {
      this.$emit("checkout", this.customerDataInformation);
      this.close();
    }
  }
};
</script>

<template>
  <vue-bottom-sheet-vue2
    ref="orderSheet"
    :max-width="500"
    :init-sheet-height="2000"
    :max-height="2000"
    :swipe-able="false"
    overlay-color="rgba(0,0,0,0.6)"
    @closed="closeOrderRequiredDataSheet()"
    class="order-bottom-sheet"
  >
    <template #drag>
      <div class="d-flex align-items-center justify-content-between w-100">
        <b-button @click="close" variant="light" class="ml-4 rounded-circle shadow-sm">
          <img alt="arrowLeft" width="20" src="@/assets/icons/arrow-left-black.svg" />
        </b-button>
        <h5 class="text-center text-dark text-uppercase flex-grow-1 m-0 mr-4 font-weight-bold">
          Informations de commande
        </h5>
      </div>
    </template>

    
    <template #header >
       
    </template>

    <template #default>
      <div class="p-3 mb-5 s">

        <div class="cart-summary-card mb-4">
          <div class="cart-summary-header">
            <div class="icon-box">
              <i class="fas fa-shopping-bag"></i>
            </div>

            <div>
              <div class="cart-label">Votre Panier</div>
              <div class="cart-items">{{ draftCountItems }} article<span v-if="draftCountItems > 1">s</span></div>
            </div>
          </div>

          <div v-if="cartTotal" class="cart-summary-total">
            <span>Total</span>
            <span class="total-amount">{{ cartTotal }}</span>
          </div>
        </div>


        <div class="card field-card mb-4">
          <div class="card-body p-3">

            <div v-if="fullNameRequired" class="mb-3">
              <label for="name" class="form-label fw-bold" :style="{ color: rgbText }">
                Nom et Prénom <span v-if="fullNameRequired" class="text-danger">*</span>
              </label>

              <div v-if="validationErrors.name" class="missingFieldsAlert">
                {{ validationErrors.name }}
              </div>
              <b-input-group class="soft-input-group">
                <b-input-group-prepend class="input-group-prepend">
                  <span class="input-group-text soft-icon">
                    <img alt="" width="20" src="@/assets/icons/user-g.svg" />
                  </span>
                </b-input-group-prepend>

                <b-form-input
                  v-model="customerDataInformation.name"
                  id="name"
                  type="text"
                  placeholder="Nom & Prénom"
                  maxlength="50"
                  class="soft-input"
                />
              </b-input-group>
            </div>

            <div v-if="phoneRequired" class="mb-3">
              <label for="phone" class="form-label fw-bold" :style="{ color: rgbText }">
                Téléphone <span v-if="phoneRequired" class="text-danger">*</span>
              </label>

              <div v-if="validationErrors.phone" class="missingFieldsAlert">
                {{ validationErrors.phone }}
              </div>

              <b-input-group class="soft-input-group">
                <b-input-group-prepend class="input-group-prepend">
                  <span class="input-group-text soft-icon">
                    <img alt="" width="20" src="@/assets/icons/phone.svg" />
                  </span>
                </b-input-group-prepend>

                <b-form-input
                  v-model="customerDataInformation.phone"
                  id="phone"
                  type="tel"
                  placeholder="Téléphone"
                  maxlength="50"
                  class="soft-input"
                />
              </b-input-group>
            </div>

            <div v-if="addressRequired" class="mb-3">
              <label for="address" class="form-label fw-bold" :style="{ color: rgbText }">
                Adresse <span v-if="addressRequired" class="text-danger">*</span>
              </label>

              <div v-if="validationErrors.address" class="missingFieldsAlert">
                {{ validationErrors.address  }}
              </div>

              <b-input-group class="soft-input-group">
                <b-input-group-prepend class="input-group-prepend">
                  <span class="input-group-text soft-icon">
                    <img alt="" width="20" src="@/assets/icons/address.svg" />
                  </span>
                </b-input-group-prepend>

                <b-form-input
                  v-model="customerDataInformation.address"
                  id="address"
                  type="text"
                  placeholder="Adresse"
                  maxlength="150"
                  class="soft-input"
                />
              </b-input-group>
            </div>

            <div v-if="emailRequired" class="mb-2">
              <label for="email" class="form-label fw-bold" :style="{ color: rgbText }">
                Email <span v-if="emailRequired" class="text-danger">*</span>
              </label>

              <div v-if="validationErrors.mail" class="missingFieldsAlert">
                {{ validationErrors.mail }}
              </div>

              <b-input-group class="soft-input-group">
                <b-input-group-prepend class="input-group-prepend">
                  <span class="input-group-text soft-icon">
                    <img alt="" width="20" src="@/assets/icons/address-at.svg" />
                  </span>
                </b-input-group-prepend>

                <b-form-input
                  v-model="customerDataInformation.mail"
                  id="email"
                  type="email"
                  placeholder="Email"
                  maxlength="50"
                  class="soft-input"
                />
              </b-input-group>
            </div>

          </div>
        </div>

        <div v-if="cartNote" class="card field-card mb-4">
          <div class="card-body p-3">
            <div class="mb-0">
              <p v-html="cartNote" class="mb-0" style="font-size: 14px; color: #555;"></p>
            </div>
          </div>
        </div>

        <div v-if="ageRequired" class="card field-card mb-4">
          <div class="card-body p-3">
            <label class="form-label fw-bold" :style="{ color: rgbText }">
              Tranche d'âge <span v-if="ageRequired" class="text-danger">*</span>
            </label>

            <div v-if="validationErrors.age" class="missingFieldsAlert">
              {{ validationErrors.age }}
            </div>

            <div class="row g-2 mt-2">
              <div class="col-6 col-sm-3" v-for="range in ageRanges" :key="range">
                <div
                  class="soft-select-card age-card m-2"
                  :class="{ active: customerDataInformation.age === range }"
                  @click="setAge(range)"
                >
                  {{ range }}
                </div>
              </div>
            </div>
          </div>
        </div>


        <div v-if="genderRequired" class="card field-card mb-4">
          <div class="card-body p-3">

            <label class="form-label fw-bold" :style="{ color: rgbText }">
              Genre <span v-if="genderRequired" class="text-danger">*</span>
            </label>

            <div v-if="validationErrors.name" class="missingFieldsAlert">
              {{ validationErrors.gender  }}
            </div>

            <div class="row mt-2">

              <div class="col-6" v-for="gender in genderTypes" :key="gender" >
                <div class="m-2">
                  <div class="soft-select-card"
                      :class="{ active: getGenderFromValue(customerDataInformation.gender) ===gender }"
                      @click="setGender(gender)"
                  >
                    <img
                      v-if="gender === 'Homme'"
                      src="/images/men.svg"
                      width="32"
                      class="mb-2"
                    />
                    <img
                      v-if="gender === 'Femme'"
                      src="/images/women.svg"
                      width="32"
                      class="mb-2"
                    />
                    <span>{{ gender }}</span>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>



        <div v-if="customFieldsRequired" class="card field-card mb-4">
          <div class="card-body p-3">
            <label class="form-label fw-bold" :style="{ color: rgbText }">
              {{ fieldsQuestion }} <span v-if="customFieldsRequired" class="text-danger">*</span>
            </label>

            <div v-if="validationErrors.customFields" class="missingFieldsAlert">
              {{ validationErrors.customFields }}
            </div>
            <b-input-group class="soft-input-group mt-1">
              <b-form-input
                v-model="customerDataInformation.customFields"
                type="text"
                maxlength="200"
                class="soft-input"
              />
            </b-input-group>
          </div>
        </div>


        <div v-if="customDropDownRequired" class="card field-card mb-5">
          <div class="card-body p-3">
            <label class="form-label fw-bold" :style="{ color: rgbText }">
              {{ dropDownQuestion }} <span v-if="customDropDownRequired" class="text-danger">*</span>
            </label>
            <div v-if="validationErrors.customDropDown" class="missingFieldsAlert">
              {{ validationErrors.customDropDown }}
            </div>
            <b-form-select
              v-if="dropDownResponse && dropDownResponse.length"
              v-model="customerDataInformation.customDropDown"
              :options="dropDownResponse"
              class="mt-1"
            >
              <template #first>
                <b-form-select-option :value="null" disabled>
                  Sélectionnez une option
                </b-form-select-option>
              </template>
            </b-form-select>

          </div>
        </div>

      </div>
    </template>

    <template #footer>
      <div class="p-3 border-top bg-white d-flex justify-content-center footer" style="z-index: 9999;">
        <b-button
          variant="light"
          class="btn-pill text-white font-weight-bold text-uppercase checkout-btn w-100"
          style="letter-spacing: 0.1rem;"
          @click="checkout"
        >
          {{ $t('menuOrder.cart.button.submitOrder') }}
        </b-button>
      </div>
    </template>
  </vue-bottom-sheet-vue2>
</template>





<style scoped>
::v-deep .bottom-sheet__content.bottom-sheet__content--fullscreen {
  background-color: #f8f9fa !important;
  overflow-y: auto;
  padding-bottom: 20px;
}
</style>

<style scoped>

.field-card{
  border-radius: 18px;
}

.checkout-btn {
  border-radius: 25px;
  padding: 0.75rem 1.9rem;
  background: linear-gradient(90deg, #28a745, #218838);
  border: none;
  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);
  transition: all 0.2s;
}

.checkout-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(40, 167, 69, 0.4);
}

.soft-input-group {
  background: #fff;
  border: 1.5px solid #dce6f2;
  border-radius: 12px;
  overflow: hidden;
  transition: border-color .2s, box-shadow .2s;
}

.soft-input-group:focus-within {
  border-color: #228e3a !important;
  box-shadow: 0 0 0 4px rgba(34,142,58,0.25);
}

.soft-icon {
  background: transparent !important;
  border: none !important;
  padding-right: 12px;
}

.soft-input {
  border: none !important;
  background: transparent !important;
  padding-left: 8px !important;
  font-size: 12px !important;
}

.soft-input:focus {
  outline: none !important;
  box-shadow: none !important;
}

.soft-select ::v-deep .vs__dropdown-toggle {
  border: 1.5px solid #dce6f2 !important;
  border-radius: 10px !important;
  padding: 10px;
}

.soft-select ::v-deep .vs__dropdown-toggle:focus {
  border-color: #228e3a !important;
  box-shadow: 0 0 0 4px rgba(34,142,58,0.25);
}

.age-btn.active,
.gender-btn.active {
  background: #e5f8e8 !important;
  border-color: #228e3a !important;
  color: #228e3a !important;
  box-shadow: 0 0 0 4px rgba(34,142,58,0.25);
}

.input-group-prepend {
  background-color: #ddd;
}

/* Soft select card (gender / age) */
.soft-select-card {
  border: 1.5px solid #dce6f2;
  background: #ffffff;
  border-radius: 14px;
  padding: 18px 10px;
  text-align: center;
  cursor: pointer;
  transition: all 0.25s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.soft-select-card:hover {
  border-color: #1f7a30;
  background: #f0f9f2;
}

.soft-select-card.active {
  border-color: #228e3a !important;
  background: #e5f8e8 !important;
  box-shadow: 0 0 0 4px rgba(34,142,58,0.25);
}

.soft-select-card img {
  opacity: 0.9;
}

.soft-select-card span {
  font-weight: 600;
  color: #2d3a4b;
}

.missingFieldsAlert {
  color: #721c24;
  margin-bottom: 2px;
  font-size: 10px;
}
</style>

<style scoped>
.cart-summary-card {
  position: relative;
  border-radius: 18px;
  padding: 18px 20px;
  background: rgba(255, 255, 255, 0.95);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(240, 240, 240, 0.8);
  backdrop-filter: blur(8px);
  transition: transform .2s ease, box-shadow .3s ease;
  overflow: hidden;
}

.cart-summary-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.12);
}

/* Decorative gradient wave */
.cart-summary-card::after {
  content: '';
  position: absolute;
  top: -40px;
  right: -40px;
  width: 140px;
  height: 140px;
  background: radial-gradient(circle at top right, #8cd48f, #228e3a);
  opacity: 0.15;
  border-radius: 50%;
}

/* Header */
.cart-summary-header {
  display: flex;
  align-items: center;
  gap: 15px;
}

.icon-box {
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, #228e3a, #76c476);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 20px;
  box-shadow: 0 6px 14px rgba(34, 142, 58, 0.25);
}

.cart-label {
  font-size: 14px;
  font-weight: 600;
  color: #7d8892;
  margin-bottom: 2px;
}

.cart-items {
  font-size: 18px;
  font-weight: 700;
  color: #2a3b4c;
}

/* Total section */
.cart-summary-total {
  margin-top: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 17px;
  font-weight: 600;
  color: #4f5d69;
}

.total-amount {
  font-size: 22px;
  font-weight: 800;
  color: #228e3a;
}

</style>